import { render } from "./AuthPoweredBy.vue?vue&type=template&id=bbb746bc&scoped=true"
import script from "./AuthPoweredBy.vue?vue&type=script&lang=js"
export * from "./AuthPoweredBy.vue?vue&type=script&lang=js"

import "./AuthPoweredBy.vue?vue&type=style&index=0&id=bbb746bc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbb746bc"]])

export default __exports__